<template>
  <div class="setting-popup setting-pathEffect"  v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }" @mousedown="stopDocument($event)">
    <div class="setting-popup__drag-area" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': 'move'}">
      设置
    </div>
    <div class="setting-popup__content">
      <div class="target-change target-fill-color" v-if="hasFillColor">
        <label for="">颜色</label>
        <div :style="{backgroundColor: this.fillColor}" @click="showColorPciker"></div>
      </div>
      <div class="target-change target-text-color" v-if="hasTextColor">
        <label for="">颜色</label>
        <div :style="{backgroundColor: this.textColor}" @click="showColorPciker"></div>
      </div>
      <!-- 透明度 -->
      <div class="target-change target-opacity">
        <label>
          透明度
        </label>
        <slider-prop
          :runway-size="114"
          :number-unit="'%'"
          @updateValue="onSliderValueUpdated"
          ref="sliderRef"
        ></slider-prop>
      </div>
    </div>
    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
  </div>
</template>

<script>
import popup from '../mixins/popup'
import sliderProp from './content/slider';

export default {
  mixins: [popup],
  components: {
    sliderProp
  },
  data () {
    return {
      popupType: 'pathTargetSetting',
      opacity: 0,
      hasFillColor: false,
      fillColor: '#ffffff',
      hasTextColor: false,
      textColor: '#ffffff',
      dragHandle: false
    }
  },
  watch: {
    'boxData.judgeBox': function (val) {
      if (val) {
        this.initData();
        this.$nextTick(() => {
          this.$refs.sliderRef && this.sprite
            && this.$refs.sliderRef.updateValFromOutside(this.sprite.toTransparent(this.opacity));
        }, 500)
      }
    },
  },
  mounted () {
    this.$bus.on('colorPickerInput.pathTargetSetting', (obj) => {
      this.fillColor = obj.hex;
    });
  },
  methods: {
    initData(){
      let target = this.sprite.effect.pathAnim.target;
      this.hasFillColor = this.sprite.type === 'Svg'
        && this.$isEditableShape(this.sprite.option.fileType)
        ? true : false;
      this.hasTextColor = this.sprite.type === 'Text' && !this.sprite.artType ? true : false;
      this.opacity = typeof (target.opacity) === 'number' ? target.opacity : this.sprite.opacity;
      this.hasFillColor && (this.fillColor = target.fillColor || this.sprite.fill);
      this.hasTextColor && (this.textColor = target.textColor || this.sprite.font.color);
    },
    onSliderValueUpdated (val, undo) {
      this.$bus.emit('targetSetting_opacity', {val: val, undo: undo})
    },
    showColorPciker() {
      this.disableTextSetting = true;
      let rect = this.$el.getBoundingClientRect();
      this.$bus.emit('FeaturesPop_vue',{
				name : "color",
				posx : rect.left,
				posy : rect.top,
        type : 1,
        source: this
			});
    },
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  z-index: 35;
  border-radius: 6px 6px 3px 3px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 10px 0 5px;
  }
}

.target-change {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding-left: 14px;
  padding-right: 13px;
  margin-top: 10px;
  margin-bottom: 20px;

  label {
    margin-right: 13px;
  }
}

.target-opacity {
  .input-number {
    display: inline-flex;
    margin-left: 7px;
    div, span {
      display: inline-flex;
      justify-content: center;
      align-items: center;
    }
    .number-box {
      width: 30px;
      height: 30px;
      color: #474261;
      border: solid 1px #f0f0f8;
      margin-right: 2px;
      input {
        width: 100%;
        height: 100%;
        outline: none;
        border: none;
        text-align: center;
      }
    }
    div {
      flex-direction: column;
      .plus-btn {
        width: 20px;
        height: 14px;
        color: #4a4563;
        background-color: #f0f0f8;
        border-radius: 0px 4px 0px 0px;
        cursor: pointer;
        margin-bottom: 2px;
      }
      .minus-btn {
        width: 20px;
        height: 14px;
        color: #4a4563;
        background-color: #f0f0f8;
        border-radius: 0px 0px 4px 0px;
        cursor: pointer;
      }
    }
  }
}

.target-fill-color,.target-text-color {
  > div {
    width: 75px;
    height: 30px;
    border-radius: 4px;
    background-color: #5779fa;
    cursor: pointer;
    box-shadow: 0 0 3px 0px rgba(0,0,0,0.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/pathTargetSetting.vue